/* eslint-disable max-statements */
import { AppDispatch } from '../redux/store';
import { resettingActivityData } from '../redux/slices/activity';
import { resettingAppData } from '../redux/slices/index';
import { resettingAutomationData } from '../redux/slices/automation';
import { resettingChartData } from '../redux/slices/chart';
import { resettingClientData } from '../redux/slices/client';
import { resettingContactData } from '../redux/slices/contact';
import { resettingCustomerData } from '../redux/slices/customer';
import { resettingDealData } from '../redux/slices/deal';
import { resettingDomainData } from '../redux/slices/domain';
import { resettingEmailData } from '../redux/slices/email';
import { resettingError } from '../redux/slices/error';
import { resettingFileData } from '../redux/slices/file';
import { resettingFolderData } from '../redux/slices/folder';
import { resettingFormData } from '../redux/slices/form';
import { resettingGoogleCalendarData } from '../redux/slices/calendar';
import { resettingIntegrationData } from '../redux/slices/integration';
import { resettingLeadData } from '../redux/slices/leads';
import { resettingMessageBoardData } from '../redux/slices/messageboard';
import { resettingNoteData } from '../redux/slices/note';
import { resettingPipelineData } from '../redux/slices/pipeline';
import { resettingProductData } from '../redux/slices/product';
import { resettingProspectData } from '../redux/slices/prospect';
import { resettingReminderData } from '../redux/slices/reminder';
import { resettingReviewData } from '../redux/slices/review';
import { resettingSMSData } from '../redux/slices/sms';
import { resettingStageData } from '../redux/slices/stage';
import { resettingSubscriptionData } from '../redux/slices/subscription';
import { resettingTaskData } from '../redux/slices/task';
import { resettingTeamData } from '../redux/slices/team';
import { resettingWaterCoolerData } from '../redux/slices/watercooler';
import { resettingWorkFlowData } from '../redux/slices/workflow';
import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';


export const resetAllStates = (dispatch: AppDispatch | ThunkDispatch<unknown, unknown, UnknownAction>) => {
    dispatch(resettingActivityData());
    dispatch(resettingAppData());
    dispatch(resettingAutomationData());
    dispatch(resettingChartData());
    dispatch(resettingClientData());
    dispatch(resettingContactData());
    dispatch(resettingCustomerData());
    dispatch(resettingDealData());
    dispatch(resettingDomainData());
    dispatch(resettingEmailData());
    dispatch(resettingError());
    dispatch(resettingFileData());
    dispatch(resettingFolderData());
    dispatch(resettingFormData());
    dispatch(resettingGoogleCalendarData());
    dispatch(resettingIntegrationData());
    dispatch(resettingLeadData());
    dispatch(resettingMessageBoardData());
    dispatch(resettingNoteData());
    dispatch(resettingPipelineData());
    dispatch(resettingProductData());
    dispatch(resettingProspectData());
    dispatch(resettingReminderData());
    dispatch(resettingReviewData());
    dispatch(resettingSMSData());
    dispatch(resettingStageData());
    dispatch(resettingSubscriptionData());
    dispatch(resettingTaskData());
    dispatch(resettingTeamData());
    dispatch(resettingWaterCoolerData());
    dispatch(resettingWorkFlowData());
};

export const resetStatesExceptAuth = (dispatch: AppDispatch) => {
    dispatch(resettingActivityData());
    dispatch(resettingAutomationData());
    dispatch(resettingChartData());
    dispatch(resettingClientData());
    dispatch(resettingContactData());
    dispatch(resettingCustomerData());
    dispatch(resettingDealData());
    dispatch(resettingDomainData());
    dispatch(resettingEmailData());
    dispatch(resettingError());
    dispatch(resettingFileData());
    dispatch(resettingFolderData());
    dispatch(resettingFormData());
    dispatch(resettingGoogleCalendarData());
    dispatch(resettingIntegrationData());
    dispatch(resettingLeadData());
    dispatch(resettingMessageBoardData());
    dispatch(resettingNoteData());
    dispatch(resettingPipelineData());
    dispatch(resettingProductData());
    dispatch(resettingProspectData());
    dispatch(resettingReminderData());
    dispatch(resettingReviewData());
    dispatch(resettingSMSData());
    dispatch(resettingStageData());
    dispatch(resettingSubscriptionData());
    dispatch(resettingTaskData());
    dispatch(resettingTeamData());
    dispatch(resettingWaterCoolerData());
    dispatch(resettingWorkFlowData());
};

export const resetStatesExceptAuthAndClient = (dispatch: AppDispatch) => {
    dispatch(resettingActivityData());
    dispatch(resettingAutomationData());
    dispatch(resettingChartData());
    dispatch(resettingContactData());
    dispatch(resettingCustomerData());
    dispatch(resettingDomainData());
    dispatch(resettingEmailData());
    dispatch(resettingError());
    dispatch(resettingFileData());
    dispatch(resettingFolderData());
    dispatch(resettingFormData());
    dispatch(resettingGoogleCalendarData());
    dispatch(resettingIntegrationData());
    dispatch(resettingLeadData());
    dispatch(resettingMessageBoardData());
    dispatch(resettingNoteData());
    dispatch(resettingPipelineData());
    dispatch(resettingProductData());
    dispatch(resettingProspectData());
    dispatch(resettingReminderData());
    dispatch(resettingReviewData());
    dispatch(resettingSMSData());
    dispatch(resettingStageData());
    dispatch(resettingSubscriptionData());
    dispatch(resettingTaskData());
    dispatch(resettingTeamData());
    dispatch(resettingWaterCoolerData());
    dispatch(resettingWorkFlowData());
};
